import { EnumOrdersCounterTypes } from '@Model';
import { SelectOption } from '@synqo/frontend-component-library';

export function getOrderCounterName(counterType: EnumOrdersCounterTypes): string {
    switch (counterType) {
        case EnumOrdersCounterTypes.Order:
            return 'Auftrag';
        case EnumOrdersCounterTypes.CashOrder:
            return 'Barauftrag';
        case EnumOrdersCounterTypes.WeighingSlip:
            return 'Wiegeschein';
        case EnumOrdersCounterTypes.Requisition:
            return 'Bestellung';
    }
}

export const orderCounterTypes: EnumOrdersCounterTypes[] = [
    EnumOrdersCounterTypes.Order,
    EnumOrdersCounterTypes.CashOrder,
    EnumOrdersCounterTypes.WeighingSlip,
    EnumOrdersCounterTypes.Requisition,
];

export const orderCounterTypesItems: SelectOption<EnumOrdersCounterTypes>[] = orderCounterTypes.map((counterType) => ({
    name: getOrderCounterName(counterType),
    value: counterType,
    label: getOrderCounterName(counterType),
}));
